import React from 'react';
import { useTheme } from '../theme/ThemeContext';

interface ControlOverlayProps {
  flagMode: boolean;
  onToggleFlagMode: () => void;
  onRecenter: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export const ControlOverlay: React.FC<ControlOverlayProps> = ({
  flagMode,
  onToggleFlagMode,
  onRecenter,
  onZoomIn,
  onZoomOut,
}) => {
  const { theme } = useTheme();

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        zIndex: 10,
        pointerEvents: 'none',
      }}
    >
      {/* Flag Mode Toggle Button */}
      <button
        onClick={onToggleFlagMode}
        style={{
          pointerEvents: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '12px 20px',
          borderRadius: '9999px',
          backgroundColor: flagMode
            ? '#ef4444'
            : theme.isDark
            ? 'rgba(24, 24, 27, 0.9)'
            : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(12px)',
          border: `1.5px solid ${
            flagMode
              ? '#dc2626'
              : theme.isDark
              ? 'rgba(255, 255, 255, 0.2)'
              : 'rgba(0, 0, 0, 0.15)'
          }`,
          color: flagMode ? '#ffffff' : theme.textColor,
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 700,
          fontSize: '15px',
          cursor: 'pointer',
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          transition: 'all 0.2s ease',
        }}
      >
        <span style={{ fontSize: '18px' }}>🚩</span>
        <span>{flagMode ? 'FLAG MODE: ON' : 'REVEAL MODE'}</span>
      </button>

      {/* Recenter Button */}
      <button
        onClick={onRecenter}
        aria-label="Recenter Camera"
        style={{
          pointerEvents: 'auto',
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          backgroundColor: theme.isDark ? 'rgba(24, 24, 27, 0.9)' : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(12px)',
          border: `1.5px solid ${theme.isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.15)'}`,
          color: theme.textColor,
          fontSize: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        }}
      >
        🎯
      </button>

      {/* Zoom Controls */}
      <div
        style={{
          pointerEvents: 'auto',
          display: 'flex',
          borderRadius: '9999px',
          overflow: 'hidden',
          backgroundColor: theme.isDark ? 'rgba(24, 24, 27, 0.9)' : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(12px)',
          border: `1.5px solid ${theme.isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.15)'}`,
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        }}
      >
        <button
          onClick={onZoomIn}
          style={{
            width: '40px',
            height: '48px',
            background: 'none',
            border: 'none',
            borderRight: `1px solid ${
              theme.isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'
            }`,
            color: theme.textColor,
            fontFamily: '"Outfit", sans-serif',
            fontSize: '20px',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          +
        </button>
        <button
          onClick={onZoomOut}
          style={{
            width: '40px',
            height: '48px',
            background: 'none',
            border: 'none',
            color: theme.textColor,
            fontFamily: '"Outfit", sans-serif',
            fontSize: '20px',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          -
        </button>
      </div>
    </div>
  );
};
